
































































































































import * as am4core from '@amcharts/amcharts4/core';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import Vue from 'vue';
import axios from 'axios';
import bus from '@/bus';
import Data from "@/views/data/Data.vue";
import PurchaseComponent from "@/components/PurchaseComponent.vue";
import DefaultCardComponent from "@/components/DefaultCardComponent.vue";

am4core.useTheme(am4themes_animated);

export default Vue.extend({
  components: {
    "purchase-data": PurchaseComponent,
    "default-card": DefaultCardComponent
  },
    data() {
        return {
          accountBalance: 0,
          months: [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December',
          ],
          voiceBundles: [
            {text: 'Select Bundle', value: 0 },
            {text: 'R10', value: 10},
            {text: 'R20', value: 20},
            {text: 'R50', value: 50},
            {text: 'R100', value: 100},
            {text: 'R200', value: 200},
          ],
          selectedVoiceBundle: 0,
          currentMonth: '',
          product: 0,
          isUserAdmin: false,
          isDeveloper: false,
          isLoading: false,
          dialogVisible: false,
          step: 1,
          cerebroNumber: null,
          isFriendTopUp: false,
          model: {
              amount: 0,
              cardNumber: '',
              cardHolder: '',
              expDate: '',
              emailAddress: '',
              cvv: null
          },
          customer: {
            customerName: null,
            phoneNumber: null
          },
          products: [
            { text: 'Choose Bundle Type', value: 0 },
            { text: 'Airtime', value: 1 },
            { text: 'Data', value: 2 },
          ]
        };
    },
    async mounted() {
      const token = this.getlocatStorageToken();
      if (token) {
            /** get account balance */
            const res = await this.getBalance();
            let balance = Math.abs(res.data.postpaid.minLimit) - Math.abs(res.data.postpaid.balance);
            balance = balance + res.data.prepaid.balance;
            this.accountBalance = balance;
            this.isUserAdmin = res.data.isadmin;
            this.isDeveloper = res.data.developer;
            /** get cedit card details */
            let card = await this.getCard();
            if (!card.data.notFound) {
                this.model.cardHolder = card.data.card_name;
                this.model.cardNumber = card.data.card_number_masked;
                this.model.expDate = `${card.data.expiry_month}/${card.data.expiry_year}`;
            }
            /** get client details */
            const client = await this.getClient();
            this.model.emailAddress = client.data.email_address;
        } else {
            bus.$on(':tokenReceived', async () => {
                this.getBalance().then(res => {
                    this.accountBalance = res.data.balance;
                    this.isUserAdmin = res.data.isadmin;
                    this.isDeveloper = res.data.developer;
                });
            });
        }
    },
    methods: {
        async getCustomerByPhone() {
          try {
            if (!this.model.amount) {
              (this as any).$ons.notification.toast("Please select an amount", { timeout: 4000, animation: 'fall' });
              return;
            }
            if (this.isFriendTopUp) {
              this.isLoading = true;
              const result = await axios.get(`/customer-from-phone-number/${this.cerebroNumber}`);
              if (result.data && result.data.customerName && result.data.phoneNumber) {
                this.customer = result.data;
                this.step = 2;
              } else {
                (this as any).$ons.notification.toast("Account associated with phone number not found", { timeout: 4000, animation: 'fall' });
              }
            } else {
              this.step = 2;
            }
            this.isLoading = false;
          } catch (err) {
            this.isLoading = false;
            if (err.response!.data) {
              (this as any).$ons.notification.toast(err.response!.data.message, { timeout: 4000, animation: 'fall' });
            } else {
              (this as any).$ons.notification.toast("Account not found", { timeout: 4000, animation: 'fall' });
            }
          }
        },
        async topUpFriend() {
          try {
            this.isLoading = true;
            const result = await axios.post(`/voice/top-up/third-party/${this.customer.phoneNumber}`, {
              amount: this.model.amount,
              cvv: this.model.cvv
            });
            if (result.status === 200) {
              this.model.cvv = null
              this.step = 3;
            }
            this.isLoading = false;
          } catch (err) {
            this.isLoading = false;
            if (err.response!.data!.meta!.error) {
              (this as any).$ons.notification.toast(err.response.data.meta.error, { timeout: 4000, animation: 'fall' });
            } else {
              (this as any).$ons.notification.toast("Failed to top up account!", { timeout: 4000, animation: 'fall' });
            }
          }
      },
        async getBalance() {
            return axios.get('/voice/account-balance');
        },
        async getCard() {
            return axios.get('/client/credit-card');
        },
        async getClient() {
            return axios.get('/client');
        },
        async topUp() {
            try {
              this.isLoading = true;
                if (this.model.cvv) {
                  if ((this.model.cvv as any).length !== 3) {
                    this.isLoading = false;
                    (this as any).$ons.notification.toast('CVV must be 3 number long', { timeout: 4000, animation: 'fall' });
                    return;
                  }
                    const topup = await axios.post('/voice/topup', {
                        amount: this.model.amount,
                        cvv: this.model.cvv
                    });
                    if (topup.status === 200) {
                      this.step = 3;
                      this.model.cvv = null;
                      bus.$emit("NEWBALANCE");
                      (this as any).$ons.notification.toast(topup.data.message, { timeout: 4000, animation: 'fall' });
                    }
                } else {
                    (this as any).$ons.notification.toast('cvv is required', { timeout: 4000, animation: 'fall' });
                }
                this.isLoading = false;
            } catch (err) {
                this.isLoading = false;
                if (err.response!.data!.meta!.error) {
                  (this as any).$ons.notification.toast(err.response.data.meta.error, { timeout: 4000, animation: 'fall' });
                } else {
                  (this as any).$ons.notification.toast("Failed to top up account!", { timeout: 4000, animation: 'fall' });
                }
            }
        },
        getlocatStorageToken() {
            const _token = localStorage.getItem('app:ACCESS_TOKEN');
            if (!_token) {
                return undefined;
            }
            return _token;
        },
        formatCurrency(amount: number | string, decimalPlaces?: number, symbol?: string | boolean): string {
            decimalPlaces = decimalPlaces ? 2 : Math.abs(decimalPlaces as number);
            let decimalFormatter: string = '.';
            let thousandsFormatter = ' ';
            amount = this.formatNumber(amount, decimalPlaces, decimalFormatter, thousandsFormatter, symbol);
            let negative = amount < 0 ? '-' : '';
            let numberValueSplit = `${amount}.0`.split('.');
            let decimalValue = '';
            if (decimalPlaces > 0) {
                decimalValue =
                    decimalFormatter + numberValueSplit[1] + '0'.repeat(decimalPlaces - numberValueSplit[1].length);
            }
            return (
                symbol + ' ' + numberValueSplit[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsFormatter) + decimalValue
            );
        },
        formatNumber(
            amount: number | string,
            decimalPlaces?: number,
            decimalFormatter?: string,
            thousandsFormatter?: string,
            symbol?: string | boolean,
        ): number {
            decimalPlaces = decimalPlaces ? 2 : Math.abs(decimalPlaces as number);
            decimalFormatter = decimalFormatter ? '.' : decimalFormatter;
            thousandsFormatter = thousandsFormatter ? ' ' : thousandsFormatter;
            amount = Number.parseFloat(amount.toString());
            amount = this.toFixed(amount, decimalPlaces);
            return Number.parseFloat(amount.toString());
        },
        toFixed(num: number, precision: number): number {
            const firstFix = Math.round(+(num + 'e' + precision));
            const secondFix = +(firstFix + 'e' + -precision);
            return Number.parseFloat(secondFix.toFixed(precision));
        },
      cancel() {
          this.step = 1;
          this.isLoading = false;
      },
      resetTopUp() {
          this.isLoading = false;
          this.step = 1;
          this.isFriendTopUp = false;
          this.selectedVoiceBundle = 0;
          this.model.cvv = null;
          this.customer.customerName = null;
          this.customer.phoneNumber = null;
      },
      addDays(days: number) {
        const date = new Date(Date.now());
        date.setDate(date.getDate() + days);
        return date;
      }
    },
});
